import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ReportBudgetRisksOpportunitiesIndexTable from './ReportBudgetRisksOpportunitiesIndexTable';

function ReportBudgetRisksOpportunitiesIndex(props) {
    return (
        <ReportBudgetRisksOpportunitiesIndexTable
            reportBudgetRisksOpportunitiesIndexUrl={reportBudgetRisksOpportunitiesIndexUrl}
            reportBudgetRisksOpportunitiesExportUrl={reportBudgetRisksOpportunitiesExportUrl}
        />
    );
}

export default ReportBudgetRisksOpportunitiesIndex;
if (document.getElementById('ReportBudgetRisksOpportunitiesIndex')) {
    var rootEl = document.getElementById('ReportBudgetRisksOpportunitiesIndex');
    ReactDOM.render(
        <App>
            <ReportBudgetRisksOpportunitiesIndex />
        </App>,
        rootEl,
    );
}
